module.exports = __webpack_public_path__ + "img/2.ebd3eda0.jpg";